<template>
  <div class="flex justify-center z-[100] relative pointer-events-none">
    <div class="fixed w-[80%] max-w-[400px] top-4 mx-auto pointer-events-none">
      <div
        class="items-center ease-in-out gap-4 w-full h-full rounded-2xl pointer-events-auto bg-[#777C82] shadow-lg relative ripple p-5"
        @click="isVisible = false"
        :class="{
          'duration-[250ms] opacity-0 -top-[150px] scale-[0.95]': !isVisible,
          'duration-[400ms] opacity-100 top-0 scale-100': isVisible,
        }"
      >
        <div>
          <div class="flex items-center gap-2">
            <div class="w-5 h-5 min-w-5">
              <img :src="icons[type] || icons.info" class="w-full h-full" />
            </div>
            <div class="textComponent text-white font-bold" bold>
              {{ title }}
            </div>
          </div>
          <div class="py-2"></div>
          <div class="textComponent text-sm text-[#C6CBCB]">
            {{ body }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import infoIcon from '../../assets/images/all/information-white.svg'
import successIcon from '../../assets/images/all/check-white.svg'
import warningIcon from '../../assets/images/all/remove-red.svg'
import dangerIcon from '../../assets/images/all/remove-red.svg'

export default defineComponent({
  name: 'AlertComponent',
  components: {},
  props: {},
  data() {
    return {
      isVisible: false,
      showingTimeout: 0,
      hidingTimeout: 0,
      type: '',
      title: '',
      body: '',
      lastHideDate: 0,
      defaultToastTimeout: 4000,
      icons: {
        info: infoIcon,
        success: successIcon,
        warning: warningIcon,
        danger: dangerIcon,
      },
    }
  },
  mounted() {
    this.$Events.handleEvent('toast_notification', this.toastNotification)
    try {
      window.toastNotification = this.directToastNotification
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    directToastNotification(type, body, title, delay, timeout) {
      this.toastNotification({ type, title, body, delay, timeout })
    },
    toastNotification(data) {
      if (!data) return
      const {
        type,
        title,
        body,
        delay = 0,
        timeout = this.defaultToastTimeout,
      } = data
      if (!body) return

      clearTimeout(this.showingTimeout)
      clearTimeout(this.hidingTimeout)

      let newToastDelay = delay
      if (this.isVisible || !this.hiddingGotEnoughAnimatedToShowNew)
        newToastDelay += 150
      this.isVisible = false

      this.showingTimeout = setTimeout(() => {
        this.type = type || 'info'
        this.title = title || 'Info'
        this.body = body
        this.isVisible = true
      }, newToastDelay)

      this.hidingTimeout = setTimeout(() => {
        this.isVisible = false
      }, newToastDelay + timeout)
    },
  },
  watch: {
    isVisible() {
      if (!this.isVisible) this.lastHideDate = Date.now()
    },
  },
  computed: {
    hiddingGotEnoughAnimatedToShowNew() {
      return Date.now() - this.lastHideDate > 1500
    },
  },
})
</script>
